import { render, staticRenderFns } from "./BeneficiosView.vue?vue&type=template&id=1e9fef59&"
import script from "./BeneficiosView.vue?vue&type=script&lang=ts&"
export * from "./BeneficiosView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports